import React from 'react';

import prosIcon from '_images/checkmark.svg';
import consIcon from '_images/crossmark.svg';

function OSProsConsTablePreview(props) {
  return (
    <div className="bg-os-light-blue-25 rounded-lg grid xl:grid-cols-2 p-6 gap-6 mb-6 sm:p-8 sm:gap-8 sm:mb-8">
      <div>
        <div className="text-lg sm:text-xl font-bold">What we like:</div>
        <div className="flex flex-col gap-y-4 mt-4">
          {(props.value?.prosList || []).map((item, index) => (
            <div key={index} className="flex gap-x-4">
              <div className="flex-shrink-0">
                <img src={prosIcon} alt="pros" className="w-[24px] h-[24px]" />
              </div>
              <div className="flex-1 mt-0.5">{item}</div>
            </div>
          ))}
        </div>
      </div>
      <div>
        <div className="text-lg sm:text-xl font-bold">What we dislike:</div>
        <div className="flex flex-col gap-y-4 mt-4">
          {(props.value?.consList || []).map((item, index) => (
            <div key={index} className="flex gap-x-4">
              <div className="flex-shrink-0">
                <img src={consIcon} alt="cons" className="w-[24px] h-[24px]" />
              </div>
              <div>{item}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default OSProsConsTablePreview;
